import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-cedant-program-details',
  templateUrl: './cedant-program-details.component.html',
  styleUrls: ['./cedant-program-details.component.scss']
})
export class CedantProgramDetailsComponent implements OnInit {
  constructor() {
  }

  tab = 1;
  reinsurerList = [];
  filesList = [];

  ngOnInit(): void {

    this.reinsurerList = [
      {id: 1, name: 'Reinsurer 1', online: true, numberOfContracts: 3},
      {id: 2, name: 'Reinsurer 2', online: true, numberOfContracts: 3},
      {id: 3, name: 'Reinsurer 3', online: false, numberOfContracts: 3},
      {id: 4, name: 'Reinsurer 4', online: true, numberOfContracts: 0}
    ];

    this.filesList = [
      {
        id: 1,
        modifiedBy: 'Johnson, Sally',
        modifiedDate: 'Mar 11, 2019 @ 12:04',
        type: 'folder',
        name: 'Folder 1',
        size: '10MB'
      },
      {
        id: 1,
        modifiedBy: 'Johnson, Sally',
        modifiedDate: 'Mar 11, 2019 @ 12:04',
        type: 'folder',
        name: 'Folder 1',
        size: '10MB'
      },
      {
        id: 1,
        modifiedBy: 'Johnson, Sally',
        modifiedDate: 'Mar 11, 2019 @ 12:04',
        type: '/assets/images/xls.png',
        name: 'file1.xls',
        size: '10MB'
      },
      {
        id: 1,
        modifiedBy: 'Johnson, Sally',
        modifiedDate: 'Mar 11, 2019 @ 12:04',
        type: '/assets/images/pdf.png',
        name: 'file1.pdf',
        size: '10MB'
      },
      {
        id: 1,
        modifiedBy: 'Johnson, Sally',
        modifiedDate: 'Mar 11, 2019 @ 12:04',
        type: '/assets/images/xls.png',
        name: 'file2.xls',
        size: '10MB'
      },
      {
        id: 1,
        modifiedBy: 'Johnson, Sally',
        modifiedDate: 'Mar 11, 2019 @ 12:04',
        type: '/assets/images/pdf.png',
        name: 'file2.pdf',
        size: '10MB'
      },
    ];

  }

  selectTab(value) {
    this.tab = value;
  }

}
